import { useCallback } from "react";

import { useNavigationHooks } from "..";
import { useDealActions, useDealIdSelector, useViewActions } from "../../store";
import { INotification, UrlQueryParams } from "../../store/types";
import { NotificationHandlerType } from "./use-click-handler";

export function useFileHook(): NotificationHandlerType {
  const { scrollToQuestionAction } = useViewActions();
  const { getDealAndStoreAction } = useDealActions();
  const currentDealId: number | undefined = useDealIdSelector();
  const { getFilePathName, getFormPathName, setParams } = useNavigationHooks();

  return useCallback(
    async ({ components }: INotification) => {
      const searchObj: UrlQueryParams = {};

      if (currentDealId == components.deal_id) {
        await getDealAndStoreAction(components.deal_id);
      }

      if (!components.file_id) return;

      searchObj.section = components.section_id || components.target_section_id;
      if (components.form_id) {
        searchObj.boxForm = components.form_id;
        searchObj.boxFormAttach = components.form_id;
        searchObj.boxFormFormAttach = components.form_id;
        searchObj.boxFormQuestAttach = components.form_id;
      }
      if (components.question_id) {
        searchObj.formQuestAttach = components.question_id;
      }

      if (components.type === "deleted") {
        setParams({
          pathname: `/main/deal/${components.deal_id}`,
          search: searchObj
        });
        return;
      }

      // in case file belongs to question, open form
      if (components.question_id && components.form_id) {
        setParams({
          pathname: getFormPathName(components.deal_id, components.form_id),
          search: searchObj
        });
        scrollToQuestionAction(true);
        return;
      }

      // Show file in databox
      if (!components.question_id) {
        setParams({
          pathname: getFilePathName(components.deal_id, components.file_id),
          search: searchObj
        });
      }
    },
    [currentDealId]
  );
}
